import { useState } from 'react';
import { useAuth } from 'react-oidc-context';

import { Question16 } from '@ingrid/iconography/react';
import { Share16 } from '@ingrid/iconography/react';
import { App, Avatar, DropdownMenu, IconButton, ThemeSwitch } from '@ingrid/luterkort-react';

import { Environment } from '~src/components/Environment/Environment';
import { LanguageSelector } from '~src/i18n/language-selector';
import { useTranslation } from '~src/i18n/use-translation';
import { useLogout } from '~src/main/hooks/useLogout';

import { ExternalRoute } from '../routes';

export function AppTopBar() {
  const { logout } = useLogout();
  const { t } = useTranslation();
  const { user } = useAuth();

  const [isLanguageSelectorOpen, setLanguageSelectorOpen] = useState(false);

  const userInitial = (user?.profile?.email ?? '').slice(0, 2).toUpperCase();

  return (
    <App.TopBar>
      <Environment />

      <ThemeSwitch />

      <DropdownMenu.Root>
        <DropdownMenu.Trigger>
          <IconButton aria-label={t('topBar.helpCenter')} size="sm" variant="quaternary">
            <Question16 />
          </IconButton>
        </DropdownMenu.Trigger>
        <DropdownMenu.Content>
          <DropdownMenu.Item asChild>
            <a
              style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}
              href={ExternalRoute.HELP_CENTER}
              rel="noreferrer"
              target="_blank"
            >
              {t('topBar.helpCenter')}
              <Share16 />
            </a>
          </DropdownMenu.Item>
          <DropdownMenu.Item asChild>
            <a
              style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}
              href={ExternalRoute.REPORT_ISSUE}
              rel="noreferrer"
              target="_blank"
            >
              {t('topBar.reportIssue')}
              <Share16 />
            </a>
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Root>

      <DropdownMenu.Root>
        <DropdownMenu.Trigger aria-label={t('common.user')}>
          <Avatar>{userInitial}</Avatar>
        </DropdownMenu.Trigger>
        <DropdownMenu.Content>
          <DropdownMenu.Item
            onClick={() => {
              /*
               * Hack: There is some problem with jumping focus and "too much
               * recursion" when this is invoked directly.
               */
              setTimeout(() => setLanguageSelectorOpen(true));
            }}
          >
            {t('topBar.language')}
          </DropdownMenu.Item>
          <DropdownMenu.Item onClick={logout}>{t('topBar.logOut')}</DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Root>

      <LanguageSelector open={isLanguageSelectorOpen} setOpen={setLanguageSelectorOpen} />
    </App.TopBar>
  );
}
